import { memo } from 'react';
import { LABEL_STYLE } from '../shared/constants';
import { InnovationTooltip } from '../shared/InnovationTooltip';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList,
} from 'recharts';
import { ChartWrapper } from '../shared/ChartWrapper';
import { NoChartData } from '../shared/NoChartData';
import { useInnovationData } from './useInnovationData';

export const InnovationUseLevelChart = memo(function InnovationUseLevelChart() {
  const { useLevelDistribution, innovationResults } = useInnovationData();

  const hasData = useLevelDistribution && Object.keys(useLevelDistribution).length > 0;
  if (!hasData) return (
    <ChartWrapper title="Innovation Use Level Distribution">
      <NoChartData message="No use-level scores assigned" detail='This chart visualizes Innovation Use Level ratings (scale 1-9). None of the innovation results in the current selection have a use-level score.' />
    </ChartWrapper>
  );

  const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const data = levels.map(l => ({ level: `Level ${l}`, count: useLevelDistribution[l] || 0 }));
  const totalN = Object.values(useLevelDistribution).reduce((s, v) => s + v, 0);
  const exportData = levels.map(l => ({ Level: l, Count: useLevelDistribution[l] || 0 }));

  return (
    <ChartWrapper title="Innovation Use Level Distribution" info="Distribution of Innovation Use Levels (1–9) across all innovation use results. Higher levels indicate wider adoption and scaling." chartData={exportData} exportFilename="innovation-use-level" sourceResults={innovationResults}>
      <p className="text-sm text-gray-500 mb-3">
        Distribution of <strong>{totalN} innovation results</strong> across use levels 1-9, where higher levels indicate broader adoption and use.
      </p>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data} margin={{ top: 20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="level" tick={{ fontSize: 11 }} interval={0} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip content={<InnovationTooltip unit="innovations" labelKey="level" />} />
          <Bar dataKey="count" fill="#8B5CF6" radius={[4, 4, 0, 0]}>
            <LabelList dataKey="count" position="top" style={LABEL_STYLE} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <p className="text-xs text-gray-400 text-center mt-1">Based on {totalN} innovation use results</p>
    </ChartWrapper>
  );
});
